import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Layout from "./components/Layout";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Contracts from "./pages/Contracts";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

// Wrapper to conditionally show Layout
const AppContent = () => {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';

  if (isAdminPage) {
    return (
      <>
        <Routes>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contracts" element={<Contracts />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <WhatsAppButton />
    </Layout>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
